module.exports = __webpack_public_path__ + "static/media/11.8021de93.png";